import { getCookieByName } from "../../../../utils";
import { useHistory } from "react-router-dom";

export function useMenuNavigation() {
  const history = useHistory();
  let branch = localStorage.getItem("easygestorweb_current_branch");
  branch = JSON.parse(branch);

  const scrollPage = (menu) => {
    const hasSub = menu.tree && menu.tree.length;
    if (!hasSub) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const preventAccessPage = (menu, appContext) => {
    if (
      ["Filiais", "Ver Filiais", "Cadastrar", "Contabilidade"].includes(menu.label)
    ) {
      return;
    }

    const branchOwnerID = getCookieByName("branch_owner_id");

    if (!branchOwnerID) {
      history.push("/branches/create");
      return;
    }

    if (!appContext.currentBranch || !appContext.currentBranch.branch_plan) {
      history.push("/plans/select");
    }
  };

  const nfeNavigator = (path) => {
    if (path === "/nfe/issuer" && (!branch || !branch.certificate)) {
      history.push("/digital-certificate");
    }
  };

  const accessFinancialModule = (appContext) => {
    if (location.pathname.includes("/financial/")) {
      const currentBranch = appContext.currentBranch;
      if (currentBranch && currentBranch.branch_plan) {

        const planId = currentBranch.branch_plan.plan;
        return (
          planId === "b85046a1-3803-4ee4-a858-8ef2c26d9d76" ||
          planId === "3c38ed4a-d8a2-4766-8f22-12fd6fec6ec0"
        );
      }
      return false;
    }
  };

  const manageNavigation = (menu, appContext) => {
    const hasSubItems = menu.tree && menu.tree.length > 0;

    // Navega apenas se não houver submenu
    if (!hasSubItems) {
      history.push(menu.path);
    }

    scrollPage(menu);
    preventAccessPage(menu, appContext);
    nfeNavigator(menu.path);
  };

  return [manageNavigation, accessFinancialModule];
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/hooks/index.js